export enum StorageKeys {
    user = '__&User&__',
    accessToken = '__&AccesToken&__',
    loginState = '__&LoginState&__',
    lastBasketOccasion = 'lastBasketOccasion',
}
